import type { CSSProperties, ReactNode } from "react";

import { cx, styled } from "simplydo/react/styled";

import type { UISize } from "../utils/UIContext";
import { SIZE_FONT } from "../utils/colors";

export type LoaderSize = UISize;

export type LoaderProps = {
  size?: LoaderSize;
  content?: ReactNode;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

type StyleProps = { $size?: LoaderSize };

const SIZE_PX: Record<LoaderSize, string> = {
  small: "1em",
  medium: "1.4285em",
  large: "1.7142em",
};

const StyledLoader = styled.div<StyleProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
  font-size: ${({ $size }) => SIZE_FONT[$size || "medium"] || "1rem"};
  color: rgba(0, 0, 0, 0.6);

  position: relative;
  margin-left: auto;
  margin-right: auto;

  &::before {
    content: "";
    display: block;
    width: ${({ $size }) => SIZE_PX[$size || "medium"] || "1.4285em"};
    height: ${({ $size }) => SIZE_PX[$size || "medium"] || "1.4285em"};
    border-radius: 500rem;
    border: 0.2em solid rgba(0, 0, 0, 0.1);
    border-top-color: #767676;
    animation: sdo-loader-spin 0.6s linear infinite;
    box-sizing: border-box;
  }

  @keyframes sdo-loader-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const Text = styled.div`
  font-weight: bold;
  text-align: center;
`;
const LoaderComponent = (props: LoaderProps) => {
  const { size, content, children, className, style } = props;
  const body = content !== undefined ? content : children;

  return (
    <StyledLoader
      className={cx(className)}
      style={style}
      $size={size}
      aria-busy={true}
      role="status"
    >
      {body != null && body !== false ? <Text>{body}</Text> : null}
    </StyledLoader>
  );
};

export const Loader = styled(LoaderComponent)``;
